import { IModalUtilities } from "types";

export const fakeModalProps = (): IModalUtilities => ({
    canClose: true,
    closeModal: jest.fn(),
    isOpen: false,
    onCloseModal: jest.fn(),
    openModal: jest.fn(),
});
